<template>
  <div id="app" class="app">
    <div class="banner">
      <div
        class="banner-box"
        v-if="Array.isArray(bannerData) && bannerData.length !== 0"
      >
        <van-swipe
          class="index-swiper-container"
          :autoplay="3000"
          indicator-color="white"
        >
          <van-swipe-item
            v-for="item of bannerData"
            :key="item.id"
            class="index-swiper-wrapper"
            @click="link(item)"
          >
            <img :src="item.imageUrl" alt="" class="index-swiper-img" />
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="home-top" v-if="leadJoin || !getToken">
        <div class="join-org">
          <img class="vip-icon" src="./img/vip.png" alt="" />
          <span class="tip"
            >{{
              joinState == 1
                ? "您尚未加入当前医院"
                : joinState == 2
                ? "您已申请加入医院，正在审核中"
                : "您已成功加入医院"
            }}
          </span>
          <div
            class="action"
            @click="
              joinOrg({ type: joinState == 1 ? 1 : joinState == 3 ? 3 : null })
            "
          >
            <span>{{
              joinState == 1 ? "我想加入" : joinState == 2 ? "" : "我知道了"
            }}</span>
            <Icon name="arrow" />
          </div>
        </div>
      </div>
    </div>
    <div v-if="isNoData">
      <NoData
        category="lesson.gif"
        :tipword="'当前医院尚未上架任何课程'"
        :outStyle="{ height: 'auto', marginTop: '50px' }"
        v-if="Array.isArray(bannerData) && bannerData.length !== 0"
      ></NoData>
      <NoData
        category="lesson.gif"
        :tipword="'当前医院尚未上架任何课程'"
        v-else
      ></NoData>
    </div>
    <!-- 课程专区 -->
    <div v-if="Array.isArray(pageList) && pageList.length !== 0">
      <div v-for="(allItem, allindex) in pageList" :key="allindex">
        <div
          v-if="
            allItem.type == 1 &&
              Array.isArray(allItem.list.courseList) &&
              allItem.list.courseList.length !== 0
          "
        >
          <div class="drawer" :style="{ 'max-height': allItem.height }">
            <div :ref="'drawer' + allindex" :class="'drawerH' + allindex">
              <p class="plate-name" ref="plateName">
                {{ allItem.list.name }}
              </p>
              <div class="course-list" ref="courseList">
                <CourseItem
                  v-for="(item, index) in allItem.list.courseList"
                  :key="index"
                  :row="item"
                  class="course-item"
                  @clickBackFn="clickBackFn"
                />
              </div>
            </div>
          </div>
          <van-button
            :class="'showMore' + allindex"
            class="show-more"
            type="default"
            block
            @click="showMoreFn(allindex)"
            v-if="allItem.list.courseList.length > 4"
            >{{ allItem.showMoreTxt }}</van-button
          >
        </div>
      </div>
    </div>
    <!--    <div v-if="Array.isArray(goodsList) && goodsList.length !== 0">-->
    <!--      <p class="plate-name" ref="plateName">所有课程</p>-->
    <!--      <CourseItem-->
    <!--        v-for="(item, ind) in goodsList"-->
    <!--        :row="item"-->
    <!--        :key="ind"-->
    <!--        class="course-item"-->
    <!--        @clickBackFn="clickBackFn"-->
    <!--      />-->
    <!--      <van-button-->
    <!--        v-if="!courseLoad.finished"-->
    <!--        class="show-more"-->
    <!--        type="default"-->
    <!--        block-->
    <!--        @click="onLoad(1)"-->
    <!--        >{{ courseLoad.allCoursseTxt }}</van-button-->
    <!--      >-->
    <!--    </div>-->
    <Popup
      v-model="displayGift"
      class="gift-dialog"
      :close-on-click-overlay="false"
    >
      <span class="title1">获得新券包！</span>
      <span class="title2"
        >可兑换{{ couponData && couponData.cardCouponCount }}个课程</span
      >
      <span class="btn" @click="jump">查看</span>
      <span class="msg">你也可以在“我的劵包”里查看</span>
      <img
        src="./img/close.png"
        class="close"
        alt=""
        @click="reportedMessageFn"
      />
    </Popup>
    <Popup
      v-model="displayJoinOrg"
      class="join-dialog"
      :close-on-click-overlay="false"
    >
      <img src="./img/dialog.png" alt="icon" class="join-dialog-icon" />
      <span class="join-dialog-msg">
        你收到了医院邀请，<br />点击下方按钮即可加入当前医院~</span
      >
      <van-button
        class="join-btn"
        type="default"
        block
        color="#FF4444"
        round
        @click="joinOrg({ type: 2 })"
        >加入医院</van-button
      >
    </Popup>
    <TabBar active="home"></TabBar>
    <img src="./img/toast.png" alt="提示" class="infoImg" v-if="isToast" />
    <TestingInfo ref="testing"></TestingInfo>
    <RemarkName
      ref="remark"
      :joinType="isJoin"
      @remarkNameSuccess="remarkNameSuccess"
    ></RemarkName>
    <FillInfo />
  </div>
</template>

<script>
import { Icon, Button as VanButton, Popup } from "vant";
import NoData from "@/components/NoData/NoData.vue";
import TabBar from "@/components/tabBar/TabBar";
import RemarkName from "./component/remarkName.vue";
// import ExamItem from "@/components/examItem/Index";
import CourseItem from "@/components/courseItem/CourseItem";
import pageMixin from "./mixin/page.js";
import { Swipe as VanSwipe, SwipeItem as VanSwipeItem } from "vant";
import TestingInfo from "./component/testingInfo.vue";
import FillInfo from "@/components/fillInfo/FillInfo";

// import JoinDialog from "./component/joinDialog";
export default {
  name: "app",
  mixins: [pageMixin],
  data: function() {
    return {};
  },
  created() {},
  mounted() {
    console.log("helllo world");
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy: function() {},
  components: {
    FillInfo,
    TabBar,
    Icon,
    VanButton,
    Popup,
    // ExamItem,
    CourseItem,
    VanSwipe,
    VanSwipeItem,
    NoData,
    TestingInfo,
    RemarkName
    // JoinDialog
  }
};
</script>
<style lang="scss" scoped>
@import "./css/index.scss";
</style>
